import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./AuthSlice";
import alertReducer from "./AlertSlice";
import menuReducer from "./MenuSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    alert: alertReducer,
    menu: menuReducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false,
    });
  },
});
export default store;
